<div *ngIf="keycloakEnabled" class="keycloak-login-loading" role="status" aria-label="Reindirizzamento al login in corso">
	<div *ngIf="!keycloakError" class="keycloak-login-loading__spinner"></div>
	<div *ngIf="keycloakError" class="keycloak-login-loading__error" role="alert">{{ keycloakError }}</div>
</div>

<style>
	.keycloak-login-loading {
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 100vh;
		background: #fff;
	}

	.keycloak-login-loading__spinner {
		width: 36px;
		height: 36px;
		border: 3px solid #e6e8eb;
		border-top-color: #36a3f7;
		border-radius: 50%;
		animation: keycloak-login-spin 0.8s linear infinite;
	}

	.keycloak-login-loading__error {
		max-width: 640px;
		margin: 24px;
		padding: 16px 20px;
		color: #721c24;
		background: #f8d7da;
		border: 1px solid #f5c6cb;
		border-radius: 4px;
		text-align: center;
	}

	@keyframes keycloak-login-spin {
		to { transform: rotate(360deg); }
	}
</style>

<div *ngIf="!keycloakEnabled" class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 m-login--select-signin"
 id="m_login">
	<div class="m-grid__item m-grid__item--order-tablet-and-mobile-2 m-login__aside">
		<div class="m-stack m-stack--hor m-stack--desktop">
			<div class="m-stack__item m-stack__item--fluid">
				<div class="m-login__wrapper">
					<div class="m-login__logo">
                        <style>
                            .main-logo {
                                max-width: 310px;
                                width: 100%;
                            }
                        </style>
						<a href="#">
							<img class="main-logo" src="./assets/app/media/img/logos/guglielmo_logo.png">
						</a>
					</div>
					<div class="m-login__select-signin">
						<div class="m-login__head">
							<h3 class="m-login__title">
								Guglielmo Dashboard Login
							</h3>
							<p class="text-justify"> Guglielmo enables a new generation of truly valuable services through its revolutionary application-aware network architecture
								for Internet access. </p>
						</div>
						<form (ngSubmit)="f.form.valid && directLogin()" #f="ngForm" class="m-login__form m-form" action="">
							<ng-template #alertSelectSignin></ng-template>
							<div class="m-login__form-action">
								<div class="row">
									<div class="col-12">
										<button [disabled]="loading" id="m_login_select_signin_direct" class="btn btn-success m-btn m-btn--pill m-btn--custom" ng-click="directLogin()">
											Login
										</button>
									</div>
								</div>
								<div class="row">
									<div class="col-12">&nbsp;</div>
								</div>
								<div class="row">
									<div class="col-12">
										<a id="m_login_select_signin_cred" class="m-link m--font-bolder right" style="cursor: pointer; color:#aaa;">
											Username and Password
										</a>
									</div>
								</div>
							</div>
						</form>
					</div>
					<div class="m-login__signin">
						<div class="m-login__head">
							<h3 class="m-login__title">
								Guglielmo Dashboard Login
							</h3>
							<p class="text-justify"> Guglielmo enables a new generation of truly valuable services through its revolutionary application-aware network architecture
								for Internet access. </p>
						</div>
						<form (ngSubmit)="f.form.valid && signin()" #f="ngForm" class="m-login__form m-form" action="">
							<ng-template #alertSignin></ng-template>
							<div class="form-group m-form__group">
								<input class="form-control m-input" type="text" placeholder="Username" name="username" [(ngModel)]="model.username" #username="ngModel"
								 autocomplete="off">
							</div>
							<div class="form-group m-form__group">
								<input class="form-control m-input m-login__form-input--last" type="password" placeholder="Password" name="password" [(ngModel)]="model.password"
								 #password="ngModel">
							</div>
<!-- 							
							<div class="row m-login__form-sub" style="display: none !important;">
								<div class="col m--align-left">
									<label class="m-checkbox m-checkbox--focus">
										<input type="checkbox" name="remember" [(ngModel)]="model.remember" #remember="ngModel"> Remember me
										<span></span>
									</label>
								</div>
								<div class="col m--align-right">
									<a href="javascript:;" id="m_login_forget_password" class="m-link">
										Forget Password ?
									</a>
								</div>
							</div> 
-->
							<div class="m-login__form-action">
								<button [disabled]="loading" [ngClass]="{'m-loader m-loader--right m-loader--light': loading}" id="m_login_signin_submit"
								 class="btn m-btn--pill m-btn--air btn-success active m-btn m-btn--custom btn-sm m--pull-left">
									Login
								</button>
								<button [disabled]="loading" id="m_login_signin_back" class="btn m-btn--pill m-btn--air btn-secondary active m-btn m-btn--custom btn-sm m--pull-right">
									Back
								</button>
							</div>
						</form>
					</div>
<!-- 					
					<div class="m-login__signup">
						<div class="m-login__head">
							<h3 class="m-login__title">
								Sign Up
							</h3>
							<div class="m-login__desc">
								Enter your details to create your account:
							</div>
						</div>
						<form (ngSubmit)="f.form.valid && signup()" #f="ngForm" class="m-login__form m-form" action="">
							<ng-template #alertSignup></ng-template>
							<div class="form-group m-form__group">
								<input class="form-control m-input" type="text" placeholder="Fullname" name="fullname" [(ngModel)]="model.fullname" #fullname="ngModel">
							</div>
							<div class="form-group m-form__group">
								<input class="form-control m-input" type="text" placeholder="Email" name="email" [(ngModel)]="model.email" #email="ngModel"
								 autocomplete="off">
							</div>
							<div class="form-group m-form__group">
								<input class="form-control m-input" type="password" placeholder="Password" name="password" [(ngModel)]="model.password" #password="ngModel">
							</div>
							<div class="form-group m-form__group">
								<input class="form-control m-input m-login__form-input--last" type="password" placeholder="Confirm Password" name="rpassword"
								 [(ngModel)]="model.rpassword" #rpassword="ngModel">
							</div>
							<div class="row form-group m-form__group m-login__form-sub">
								<div class="col m--align-left">
									<label class="m-checkbox m-checkbox--focus">
										<input type="checkbox" name="agree" [(ngModel)]="model.agree" #agree="ngModel"> I Agree the
										<a href="#" class="m-link m-link--focus">
											terms and conditions
										</a>
										.
										<span></span>
									</label>
									<span class="m-form__help"></span>
								</div>
							</div>
							<div class="m-login__form-action">
								<button [disabled]="loading" [ngClass]="{'m-loader m-loader--right m-loader--light': loading}" id="m_login_signup_submit"
								 class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air">
									Sign Up
								</button>
								<button [disabled]="loading" id="m_login_signup_cancel" class="btn btn-outline-focus  m-btn m-btn--pill m-btn--custom">
									Cancel
								</button>
							</div>
						</form>
					</div>
					<div class="m-login__forget-password">
						<div class="m-login__head">
							<h3 class="m-login__title">
								Forgotten Password ?
							</h3>
							<div class="m-login__desc">
								Enter your email to reset your password:
							</div>
						</div>
						<form (ngSubmit)="f.form.valid && forgotPass()" #f="ngForm" class="m-login__form m-form" action="">
							<ng-template #alertForgotPass></ng-template>
							<div class="form-group m-form__group">
								<input class="form-control m-input" type="text" placeholder="Email" name="email" [(ngModel)]="model.email" #email="ngModel"
								 id="m_email" autocomplete="off">
							</div>
							<div class="m-login__form-action">
								<button [disabled]="loading" [ngClass]="{'m-loader m-loader--right m-loader--light': loading}" id="m_login_forget_password_submit"
								 class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air">
									Request
								</button>
								<button [disabled]="loading" id="m_login_forget_password_cancel" class="btn btn-outline-focus m-btn m-btn--pill m-btn--custom">
									Cancel
								</button>
							</div>
						</form>
					</div> 
-->
					<div class="m-login__account" style="position: absolute; bottom: 20px;">
						<div class="row">
							<div class="col" style="font-size: 14px;color: #a9a9aa;">
								<span class="m-footer__copyright">
									&copy;&nbsp;Guglielmo&nbsp;<app-version></app-version>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="m-grid__item m-grid__item--fluid m-grid m-grid--center m-grid--hor m-grid__item--order-tablet-and-mobile-1	m-login__content"
	 style="background-image: url(./assets/app/media/img//bg/bg-caligoo.jpg)">
		<div class="m-grid__item m-grid__item--middle">

		</div>
	</div>
</div>
